import { render } from "./CreateTicket.vue?vue&type=template&id=7e780c3c"
import script from "./CreateTicket.vue?vue&type=script&lang=ts"
export * from "./CreateTicket.vue?vue&type=script&lang=ts"

import "./CreateTicket.vue?vue&type=style&index=0&id=7e780c3c&lang=css"
script.render = render

export default script